#ifdef GL_ES
precision mediump float;
#endif

attribute float sizes;
attribute vec3  aColor;
attribute float randomValue;
attribute float angle;

varying vec3  vColor;
varying float vRandomValue;
varying float vAngle;
varying float vWeight;

uniform vec3  u_center;
uniform vec3  u_camPos;
uniform float u_exponent;
uniform float u_probability;

void main() {
  vColor       = aColor;
  vRandomValue = randomValue;
  vAngle       = angle;

  vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;
  float distPC  = length(worldPos - u_center);
  float camDist = length(u_camPos  - u_center);

  float f = clamp((camDist - distPC) / camDist, 0.0, 1.0);
  float filteredWeight = 1.0 - pow(f, u_exponent);
  float applyFilter = step(vRandomValue, u_probability);
  vWeight = mix(0.0, filteredWeight, applyFilter);

  vec4 mv      = modelViewMatrix * vec4(position, 1.0);
  float baseSz = sizes * (300.0 / -mv.z);
  gl_PointSize = baseSz * (1.0 - vWeight);

  gl_Position  = projectionMatrix * mv;
}
